module.exports = __webpack_public_path__ + "img/online-money-transfer-isometric-wallets-with-coins_107791-121.ca3c398f.jpg";